var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"title-md text-center mt-5 pt-5"},[_vm._v(" "+_vm._s(_vm.$t('Welcome'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }